import React from 'react';
import {
  ThemeOverride,
  ThemeSurface,
} from '@wix/da-react-context/pkg/ThemeContext';
import c from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';

import VerificationResent from './VerificationResent';
import VerificationNeeded from './VerificationNeeded';
import s from './VerificationReminder.scss';

export interface Props {
  email: string;
  isUnverified?: boolean;
  isResendInProgress: boolean;
  isEmailChangeInProgress: boolean;
  isSendingDone: boolean;
  resendEmail: () => void;
  hideChangeEmail?: boolean;
}

export const VerificationReminder: React.FC<Props> = ({
  email,
  isUnverified,
  resendEmail,
  isEmailChangeInProgress,
  isResendInProgress,
  isSendingDone,
  hideChangeEmail,
}) => {
  const avatar_menu_sync = useFlag('avatar_menu_sync');

  return (
    <ThemeOverride
      themeSurface={ThemeSurface.TERTIARY}
      className={c(s['container'], avatar_menu_sync && s['avatar-menu-sync'])}
      tag="div"
    >
      {isSendingDone ? (
        <VerificationResent email={email} />
      ) : (
        <VerificationNeeded
          {...{
            email,
            isUnverified,
            resendEmail,
            isEmailChangeInProgress,
            isResendInProgress,
            hideChangeEmail,
          }}
        />
      )}
    </ThemeOverride>
  );
};
VerificationReminder.displayName = 'VerificationReminder';

export default VerificationReminder;
